<div class="page">
    <div class="container">
        <div class="top_area">
            <div class="item row row_ai_center">
                <app-filter-btn></app-filter-btn>
                <button (click)="openModal('createProductPopup')" type="button" class="btn dark_btn row fz_s fw_500">Создать товар <span
                        class="material-symbols-outlined fz_m">
                        add</span></button>
            </div>
            <app-filter (applyFilter)="onFilterApply($event)" (resetFilter)="onFilterReset()"
                [filterData]="productFilter" *ngIf="activeFilter">
                <app-filter-product [productFilter]="productFilter"></app-filter-product>
            </app-filter>
        </div>
        <app-table [dataMissing]="dataMissing" [data]="products" [columns]="columns" [pagination]="{
                currentPage: currentPage,
                pageSize: pageSize,
                totalItems: totalItems
            }" (pageChange)="onPageChange($event)"><app-skeleton *ngIf="isLoading" height="40" margin="15"
                count="12"></app-skeleton></app-table>
    </div>
</div>
<app-modal-create-product *ngIf="(modalService.modalState$ | async) == 'createProductPopup'" (changeState)="getProducts()"></app-modal-create-product>
<app-toastr></app-toastr>